import React from "react";
import * as helper from "../utils/helper";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

export default function ViewPoll(props: { params: { user: any; yourVoteThemeOpt1: any; yourVoteThemeOpt2: any; question: any; opt1Ratio: any; opt2Ratio: any; optionOneVotes: any; optionTwoVotes: any; totalVotes: any; yourVoteCircle: any; }; }) {
  const {
    user,
    yourVoteThemeOpt1,
    yourVoteThemeOpt2,
    question,
    opt1Ratio,
    opt2Ratio,
    optionOneVotes,
    optionTwoVotes,
    totalVotes,
    yourVoteCircle,
  } = props.params;
  return (
    <div className="row justify-content-center">
      <div className="container col-6">
        <div className="container card1">
          <div className="row col-12 title_bg">{user.name}</div>
          <p className="dateFormat">{helper.formatDate(question.timestamp)}</p>
          <div className="row">
            <div className="avatar col-4">
              <img className="image" src={user.avatarURL} alt="avatar" />
            </div>
            <div className="col-8">
              <div className="title">Results:</div>
              <div className={yourVoteCircle}>Your Vote</div>
              <div className={yourVoteThemeOpt1}>
                <div className="opt1">{question.optionOne.text}</div>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped bg-success"
                    role="progressbar"
                    style={{ width: opt1Ratio + "%" }}
                  >
                    {opt1Ratio}%
                  </div>
                </div>
                <div className="result">
                  {optionOneVotes} out of {totalVotes} votes
                </div>
              </div>
              <br />
              <div className={yourVoteThemeOpt2}>
                <div className="opt1">{question.optionTwo.text}</div>
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-striped bg-success"
                    role="progressbar"
                    style={{ width: opt2Ratio + "%" }}
                  >
                    {opt2Ratio}%
                  </div>
                </div>
                <div className="result">
                  {optionTwoVotes} out of {totalVotes} votes
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row viewBtn">
            <div className="col-3"></div>
            <Button
              as={NavLink}
              to={{
                pathname: "/",
                state: { isAnswered: false },
              }}
              className="btn alert-success btn-sm col-6"
            >
              Back
            </Button>
            <div className="col-3"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
